document.addEventListener('DOMContentLoaded', function () {
  let isTiloSyncInFlight = false;

  async function getCartJson() {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!response.ok) return null;
    return response.json();
  }

  async function resolveLineIndexByKey(lineKey) {
    if (!lineKey) return 0;
    const cart = await getCartJson();
    if (!cart || !Array.isArray(cart.items)) return 0;
    const lineIndex = cart.items.findIndex((item) => item && item.key === lineKey);
    return lineIndex >= 0 ? lineIndex + 1 : 0;
  }

  function getTargetFreeQuantity(container, newQuantity) {
    const syncContainers = document.querySelectorAll('ajax-cart-quantity[data-tilo-free-sync="true"]');
    let totalEligibleQuantity = 0;

    syncContainers.forEach((syncContainer) => {
      const input = syncContainer.querySelector('input[data-ajax-cart-quantity-input]');
      if (!input) return;

      const inputQuantity = parseInt(input.value, 10) || 0;
      if (syncContainer === container) {
        totalEligibleQuantity += newQuantity;
        return;
      }

      totalEligibleQuantity += inputQuantity;
    });

    return totalEligibleQuantity;
  }

  function handleCartQuantityClick(button, action) {
    const container = button.closest('ajax-cart-quantity');
    if (!container || !container.hasAttribute('game-day-socks-bundle')) return;

    const quantityInput = container.querySelector('input');
    const cartItem = container.closest('.cart-item');
    if (!quantityInput || !cartItem) return;

    const packInfo = container.getAttribute('data-pack-info');
    if (parseInt(packInfo, 10) === parseInt(quantityInput.value, 10) && action === 'minus') return;

    let packStep = 1;
    if (packInfo) {
      const numberMatch = packInfo.match(/\d+/);
      if (numberMatch) {
        packStep = parseInt(numberMatch[0], 10);
      } else {
        const wordToNumber = {
          one: 1,
          three: 3,
          five: 5,
          seven: 7,
          nine: 9,
          eleven: 11,
        };
        const word = packInfo.split('-')[0].toLowerCase();
        packStep = wordToNumber[word] || 1;
      }
    }

    const currentQuantity = parseInt(quantityInput.value, 10) || 0;
    const newQuantity = action === 'plus'
      ? currentQuantity + packStep
      : Math.max(packStep, currentQuantity - packStep);

    quantityInput.value = newQuantity;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function runChangeByLine(line, quantity, callback) {
    if (!line) {
      if (typeof callback === 'function') callback();
      return;
    }

    if (typeof window.liquidAjaxCart?.change === 'function') {
      window.liquidAjaxCart.change({ line, quantity }, callback ? { lastCallback: callback } : undefined);
      return;
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line, quantity }),
    })
      .then(() => {
        if (typeof callback === 'function') callback();
      })
      .catch(() => {
        if (typeof callback === 'function') callback();
      });
  }

  function runChangeByKey(lineKey, quantity, callback) {
    resolveLineIndexByKey(lineKey)
      .then((resolvedLine) => {
        runChangeByLine(resolvedLine, quantity, callback);
      })
      .catch(() => {
        if (typeof callback === 'function') callback();
      });
  }

  function syncTiloFreeSockQuantity(container, action) {
    if (container.hasAttribute('game-day-socks-bundle')) return false;
    if (container.getAttribute('data-tilo-free-sync') !== 'true') return false;

    const freeLineKey = container.getAttribute('data-tilo-free-line-key');
    const parentLineKey = container.getAttribute('data-tilo-parent-line-key');
    const quantityInput = container.querySelector('input[data-ajax-cart-quantity-input]');
    if (!parentLineKey || !quantityInput) return false;

    if (isTiloSyncInFlight) return true;
    isTiloSyncInFlight = true;

    const currentQuantity = parseInt(quantityInput.value, 10) || 0;
    const newQuantity = action === 'plus' ? currentQuantity + 1 : Math.max(0, currentQuantity - 1);
    const targetFreeQuantity = action === 'plus'
      ? getTargetFreeQuantity(container, newQuantity)
      : newQuantity;

    if (action === 'minus') {
      runChangeByKey(parentLineKey, newQuantity, () => {
        isTiloSyncInFlight = false;
      });
      return true;
    }

    if (!freeLineKey) {
      isTiloSyncInFlight = false;
      return false;
    }

    runChangeByKey(parentLineKey, newQuantity, () => {
      runChangeByKey(freeLineKey, targetFreeQuantity, () => {
        isTiloSyncInFlight = false;
      });
    });

    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      const plusBtn = e.target.closest('[data-ajax-cart-quantity-plus]');
      const minusBtn = e.target.closest('[data-ajax-cart-quantity-minus]');

      if (plusBtn) {
        const container = plusBtn.closest('ajax-cart-quantity');
        if (!container) return;

        if (syncTiloFreeSockQuantity(container, 'plus')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return;
        }

        if (container.hasAttribute('game-day-socks-bundle')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          handleCartQuantityClick(plusBtn, 'plus');
        }
      }

      if (minusBtn) {
        const container = minusBtn.closest('ajax-cart-quantity');
        if (!container) return;

        if (syncTiloFreeSockQuantity(container, 'minus')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return;
        }

        if (container.hasAttribute('game-day-socks-bundle')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          handleCartQuantityClick(minusBtn, 'minus');
        }
      }
    },
    true
  );
});

